<template>
  <div class="grid-wrap">
    <div class="grid-row">
      <article class="push__bottom">   
        <div class="grid-col grid-col--soft grid-xsmall-12 grid-large-12 push__top">
            <BackLink/>
        </div>       
        <form class="grid-col grid-col--soft grid-xsmall-12 grid-large-9 push__top">
          <Fieldset 
            title="Review your information"
            type="heading">

            <p class="push__bottom">Please review the information below. If you are happy with the information, please select the button below to submit this.  If any of the details are incorrect please return to the start.</p>

            <h2 class="beta">Young person's details</h2>            

            <dl class="summary-list">
                <div class="summary-list__row">
                    <dt class="summary-list__key">What is the young person's name?</dt>
                    <dd class="summary-list__value">{{fullName}}</dd>
                </div>                
                <div class="summary-list__row">
                    <dt class="summary-list__key">What is the young person's date of birth?</dt>
                    <dd class="summary-list__value">{{dateOfBirth}}</dd>
                </div>                
                <div class="summary-list__row">
                    <dt class="summary-list__key">What is the young person's hospital ID?</dt>
                    <dd class="summary-list__value">{{hospitalId}}</dd>
                </div>                
                <div class="summary-list__row" v-if="age >= 11 && age < 18">
                    <dt class="summary-list__key">Is the young person able to answer questions on their own without any help?</dt>
                    <dd class="summary-list__value">{{withoutHelp}}</dd>
                </div>                
                <div class="summary-list__row">
                    <dt class="summary-list__key">Does the young person attend a specialist school/hub/unit to meet their support needs?</dt>
                    <dd class="summary-list__value">{{specialistSchool}}</dd>
                </div>
                <div class="summary-list__row">
                    <dt class="summary-list__key">Is the young person in receipt of any additional support for their mental health?</dt> 
                    <dt class="summary-list__value">
                        <div>{{additionalSupport}}</div>
                        <div class="push__top" v-if="additionalSupport == 'Yes'">{{ supportText }}</div>
                    </dt>
                </div>
            </dl>

            <div v-if="age >= 5 && age < 18">
                <h2 class="beta">Completed questionnaires</h2> 
                <div class="wysiwyg push__bottom--double push__top">
                    <ul>
                        <li>Me and my epilepsy - Parent / Carer</li>
                        <li>Parent/Carer SDQ</li>
                        <li>Me and my epilepsy - Young person / Child</li>
                        <li v-if="age >= 11 && withoutHelp == 'Yes'">Young person SDQ</li>
                    </ul>
                </div>
            </div>

            <p class="push__bottom">
                <button type="submit" class="btn btn--primary" v-on:click="sendToPDF" @click.prevent :disabled="showSubmit">
                    Submit your answers 
                    <span v-if="showSubmit" class="spinner color__white" role="status"><span class="visually-hidden">Loading...</span></span>
                </button>
            </p>
            <p class="push__bottom"><button type="reset" class="btn btn--secondary" v-on:click="showModal = true" @click.prevent>Return to start</button></p>

            <div class="js-modal modal is--active" data-module="modal" v-if="showModal">
                <div class="modal__inner js-modal__dialog" role="dialog" :aria-modal="showModal" aria-labelledby="confirmation-dialog" :aria-hidden="showModal">
                    <div class="push__bottom gamma align-centre" id="confirmation-dialog">Are you sure?</div>

                    <div class="align-centre">
                        <div class="grid-col grid-col--soft push__bottom">
                            <a href="/" id="confirm" class="btn btn--primary modal-toggle-confirmation-dialog" >Yes, Return to start</a>
                        </div>
                        <div class="grid-col grid-col--soft">
                            <button id="cancel" class="btn modal-toggle-confirmation-dialog" @click="showModal = false">Cancel</button>
                        </div>
                        
                    </div>
                </div>
            </div>

          </Fieldset>
        </form>
      </article>
    </div>
  </div>
</template>

<script>
import { dataService } from '../shared';
import "isomorphic-fetch";

export default {
    components: {},
    name: "summarylist",
    props: {
        title: String
    },
    data() {
        return {
            showSubmit: false,
            showModal: false,
            submissionId: "",
            fullName: "",
            age: 0,
            hospitalId: "",
            dateOfBirth: new Date,
            questionnaire: "",
            withoutHelp: "",
            specialistSchool: "",
            additionalSupport: "",
            ParentSDQ: new Object,
            ParentImpact: new Object,
            PatientSDQ: new Object,
            PatientImpact: new Object
        };
    },
    mounted() {
        console.log("LocalStorage responses:", localStorage.getItem("responses"));
        this.loadAnswer();
    },
    methods: {
        changeValues(id) {
            this.$router.push({ name: id.toLowerCase() });
        },
        calculateAge(birthDate) {
            let today = new Date();
            let age = today.getFullYear() - birthDate.getFullYear();
            if (today.getMonth() < birthDate.getMonth() || (today.getMonth() == birthDate.getMonth() && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age;
        },
        confirmReset() {
            //Clear Data Function
            dataService.resetResponses();
            this.$router.push({ path: "/" });
        },
        sendToPDF() {
            this.showSubmit = true;
            let responses = dataService.getCompleteData();
            var model = JSON.stringify(responses);

            fetch("/Home/ProcessFormResponses", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: model
            })
            .then(response => response.text())
            .then(async (data) => {
                if (data.startsWith("Email Error: ")) {
                    alert(data.replace("Email Error: ", ""));
                } else {
                    this.emailMessage = "";
                    await Object.keys(localStorage).forEach(key => localStorage.removeItem(key));
                    this.$router.push({ name: "thankyou" });
                    localStorage.clear();

                }
            })
            .catch((error) => {
                console.log('EMAIL ERROR', error);
                this.emailMessage
            });
        },
        loadAnswer() {
            let responses = dataService.getCompleteData();
            console.log(responses); 
            this.dateOfBirth = responses.DateOfBirth.toLocaleDateString("en-GB");
            this.age = responses.Age;
            this.fullName = responses.FullName;
            this.specialistSchool = responses.SpecialistSchool;   
            this.hospitalId = responses.HospitalId;
            this.questionnaire = responses.Questionnaire;         
            this.withoutHelp = responses.WithoutHelp;         
            this.additionalSupport = responses.AdditionalSupport;
            this.supportText = responses.SupportText;
        }
    },
};
</script>